import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Row, Col, Modal, Switch, Input } from 'antd';
import { QuestionCircleFilled } from '@ant-design/icons';
import FormModal from './FormModal'
const { confirm } = Modal;
@inject('userEmailManagementStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef();
  componentDidMount() {
    const { userEmailManagementStore } = this.props;
    userEmailManagementStore.onSearchEmailAction({ email: '' })
  }
  handleSearch=()=>{
    const { userEmailManagementStore } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      userEmailManagementStore.onSearchEmailAction({email: fieldsValue.email})
    }).catch(err => {
    })
  }
  handleCreate=()=>{
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel=()=>{
    this.setState({
      addModalVisible: false
    })
  }
  handleDel=()=>{
    const { userEmailManagementStore } = this.props;
    const { selectedRows } = userEmailManagementStore
    const params= []
    selectedRows.map(item=> {return params.push(item.id)})
    confirm({
      title: 'Delete Data',
      icon: <QuestionCircleFilled />,
      content: 'Are you sure you want to delete it ?',
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk() {
        userEmailManagementStore.onDeleteEmailAction({ids: params}).then(res=>{
          if (res.data.code === 0) {
            userEmailManagementStore.onChangeSelectedRowKeys([],[])
          }
        });
      },
      onCancel() {
        console.log('Cancel');
      },
    })
    return false;
  }
  onChangeEnable =(value)=>{
    const { userEmailManagementStore } = this.props
    if(value){
      userEmailManagementStore.onEnableAction()
    }else {
      userEmailManagementStore.onDisableAction()
    }
  }
  render() {
    return (
      <>
        <Row>
            <Col span={8}>
              <Form ref={this.formRef} initialValues={{email: ''}}>
                <Row wrap={true} gutter={[10,10]}>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                    <Form.Item name='email' label='Email' labelCol={{span:4}} wrapperCol={{span:20}} rules={[{ message: 'Please enter Email without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                      <Input maxLength={100} placeholder="Please enter ..." allowClear />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col span={8} style={{textAlign: 'right'}} offset={4}>
              <Button style={{marginRight: 10}} onClick={this.handleSearch} type='primary'>Search</Button>
              <Button style={{marginRight: 10}} onClick={this.handleCreate} type='primary'>Add</Button>
              <Button onClick={this.handleDel} type='primary'>Delete</Button>
            </Col>
            <Col span={4}>
              <Form.Item name='email' label='Email' labelCol={{span:12}} wrapperCol={{span:12}} rules={[{ message: 'Please select Customer.'}]}>
                <Switch defaultChecked checkedChildren="Enable" unCheckedChildren="Disable" onChange={this.onChangeEnable} />
              </Form.Item>
            </Col>
        </Row>
        {this.state.addModalVisible?<FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        />:null}
      </>
    );
  }
}

export default SearchForm;
